











import { computed, defineComponent } from "@vue/composition-api";
import { ContentFeed } from "@scrile/api-provider/dist/projects/scrileConnect/ContentFeedProvider";
import providers from "@/lib/api";

export default defineComponent({
  name: "ContentFeedPinController",
  props: {
    contentFeed: { type: Object as () => ContentFeed, required: true },
    pinnedPostId: { type: String, default: null },
  },
  setup(props, { emit }) {
    const isPinned = computed(() => props.contentFeed.id === props.pinnedPostId);
    const isDiscoveryPinned = computed(() => !!props.contentFeed.discoveryPinTime);

    const onToggle = async (feedId: string) => {
      if (props.contentFeed.id !== feedId) return;
      try {
        await providers.ContentSetProvider.update({ data: { id: feedId, pinned: !isPinned.value } });
      } finally {
        emit("togglePin", feedId, !isPinned.value);
      }
    };

    const onToggleDiscovery = async (feedId: string) => {
      if (props.contentFeed.id !== feedId) return;
      const response = await providers.ContentSetProvider.update({
        data: { id: feedId, discoveryPinned: !isDiscoveryPinned.value },
      });
      emit("toggleDiscoveryPin", feedId, !!response.discoveryPinTime);
    };
    return {
      isPinned,
      isDiscoveryPinned,
      onToggle,
      onToggleDiscovery,
    };
  },
});
